/**
 * Artist directory — image card grid + search only
 */
(() => {
  const root = document.querySelector('[data-md-artists]');
  if (!root) return;

  const searchInput = root.querySelector('[data-md-artists-search]');
  const items = [...root.querySelectorAll('[data-md-artists-item]')];
  const countEl = root.querySelector('[data-md-artists-count]');
  const emptyEl = root.querySelector('[data-md-artists-empty]');

  // Keep Hangul syllables intact. NFKD/NFD alone turns 한글 into jamo,
  // which then get stripped by the 가-힣 filter and break Korean search.
  const normalize = (value) =>
    (value || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .normalize('NFC')
      .replace(/[^a-z0-9가-힣\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const update = () => {
    const q = normalize(searchInput?.value || '');
    let visible = 0;

    items.forEach((item) => {
      const haystack = normalize(item.dataset.search || item.textContent);
      const show = !q || haystack.includes(q);
      item.hidden = !show;
      if (show) visible += 1;
    });

    if (countEl) countEl.textContent = String(visible);
    if (emptyEl) emptyEl.hidden = visible > 0;
  };

  if (searchInput) {
    searchInput.addEventListener('input', update);
  }

  update();
})();
